import Resource from "../base/resource";
import BoundaryService from "../../../services/boundary/boundary-service";
import BoundaryFactory from "../../../services/boundary/boundary-factory";

class Boundary extends Resource {
    properties;

    constructor(props) {
        super(props);
        this.properties = props.properties ? props.properties : props;
    }

    load(onLoadCallback) {
        onLoadCallback(1);
    }

    setState(state, options) {
        if (!state || !this.properties.rules) {
            return;
        }

        this.setBoundaryConfiguration(this.properties.rules);
    }

    getDefaultState() {
        return {};
    }

    setBoundaryConfiguration(boundaries) {
        const configurations = boundaries.map(createConfiguration).filter(config => config !== null);
        BoundaryService.setConfigurations(configurations);

        function createConfiguration({type, mode, object}) {
            if (!type || !mode) {
                return null
            }

            const boundaryConfig = BoundaryFactory.create({type: type, mode: mode, ...object});

            return {
                mode: mode,
                boundaryConfig
            };
        }
    }
}

export default Boundary;
